export default __webpack_public_path__ + "static/media/u_bag-alt_active.52154b0c.svg";